<template>
    <div class="o-booking-cart" v-click-outside="hideCart">
        <button class="o-booking-cart__btn btn cl-white is-rounded" :class="{
            'has-items-in-cart': quote
        }" type="button" @click="toggleCart">
            <span class="pr-3 fw-b" v-if="quote">
                {{ currency(quote.total) }}
            </span>
            <span class="icon-cart"></span>
        </button>

        <div class="o-booking-cart-drop is-rounded cl-sec" :class="{ 'is-open': showCart }" v-if="quote && !quoteLoading">
            <div class="fs-18 fw-sb py-3 px-2 bg-sec-light-hover is-rounded">
                Your voyage
            </div>

            <ul>
                <li>
                    <div>
                        <div>
                            <div>{{ getPortById(legs.out.origin).name }} - {{ getPortById(legs.out.destination).name }}</div>
                        </div>

                        <strong>{{ getDeparture('out').format('DD MMM') }}</strong>
                    </div>

                    <div v-if="ticket != 'oneway'">
                        <div>
                            <div>{{ getPortById(legs.ret.origin).name }} - {{ getPortById(legs.ret.destination).name }}</div>
                        </div>

                        <strong>{{ getDeparture('ret').format('DD MMM') }}</strong>
                    </div>
                </li>

                <li>
                    <div v-for="(passengerItem, index) in passengerPrices" v-bind:key="index">
                        <div>
                            <div>
                                {{ passengerItem.quantity }} x {{ currency(passengerItem.price) }}<br>
                                {{ passengerItem.category }} {{ quote.class.name }} ticket
                            </div>
                        </div>

                        <div>
                            <strong class="is-strike" v-if="passengerItem.discount">
                                {{ currency(passengerItem.total + passengerItem.discount) }}
                            </strong>

                            <strong>
                                {{ currency(passengerItem.total) }}
                            </strong>
                        </div>
                    </div>

                    <!--div>
                        <div>
                            <div>
                                Standard ticket <br> winter sale offer applied
                            </div>
                        </div>

                        <strong>
                            59,00 €
                        </strong>
                    </div>

                    <div>
                        <div class="cl-red">
                            Non refundable
                        </div>
                    </div-->
                </li>

                <li v-if="quote.prices.supplements.length">
                    <div v-for="supplementItem in quote.prices.supplements" v-bind:key="supplementItem.supplement.id">
                        <div>
                            <div>
                                {{ supplementItem.quantity }} x {{ supplementItem.supplement.name }}
                            </div>
                        </div>

                        <div>
                            <strong>
                                {{ currency(parseFloat(supplementItem.total.out) + parseFloat(supplementItem.total.ret || 0)) }}
                            </strong>
                        </div>
                    </div>
                </li>

                <li v-if="quote.prices.luggage.quantity">
                    <div>
                        <div>
                            <div>
                                {{ quote.prices.luggage.quantity }} x {{ quote.prices.luggage.name }}
                            </div>
                        </div>

                        <div>
                            <strong>
                                {{ currency(parseFloat(quote.prices.luggage.total.out) + parseFloat(quote.prices.luggage.total.ret || 0)) }}
                            </strong>
                        </div>
                    </div>
                </li>

                <li v-if="transfer">
                    <div>
                        <div>
                            <div>
                                {{ transfer.quantity }} x Transfer<br />
                                {{ transfer.name }}
                            </div>
                        </div>

                        <div>
                            <strong>
                                {{ currency(transfer.total) }}
                            </strong>
                        </div>
                    </div>
                </li>

                <li>
                    <div>
                        <div>Total:</div>
                        <strong class="fs-20">{{ currency(quote.total) }}</strong>
                    </div>

                    <div v-if="quote.non_refundable">
                        <div class="cl-red">Non refundable</div>
                    </div>
                </li>
            </ul>

            <p class="cl-dark fs-14 mt-0">
                *All prices quoted do not include Venice City Tax.
            </p>
        </div>
        <div class="o-booking-cart-drop is-rounded cl-sec" :class="{ 'is-open': showCart }" v-else>
            <div class="fs-18 fw-sb py-3 px-2 bg-sec-light-hover is-rounded text-center">
                Your cart is empty
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Loader from '../components/Loader.vue'
export default {
  components: { Loader },
    data() {
        return {
            showCart: false
        }
    },
    directives: {
        ClickOutside,
    },
    computed: {
        quoteArgs() {
            return {
                trips: [
                    this.legs.out.trip ? this.legs.out.trip.id : null,
                    this.legs.ret.trip ? this.legs.ret.trip.id : null,
                ],
                accommodationClass: this.accommodationClass,
                specialOffer: this.specialOffer ? this.specialOffer.id : null,
                transfer: this.$store.state.transfer,
            }
        },
        ...mapState('booking', [
            'quote',
            'legs',
            'ticket',
            'quoteLoading',
            'accommodationClass',
        ]),
        ...mapGetters([
            'getPortById',
        ]),
        ...mapGetters('booking', [
            'getDeparture',
            'getArrival',
        ]),
        passengerPrices() {
            let prices = {}

            this.quote.prices.passengers.forEach(passenger => {
                let discount = parseFloat(passenger.discount.out) + parseFloat(passenger.discount.ret || 0)
                let total = parseFloat(passenger.total.out) + parseFloat(passenger.total.ret || 0)

                let key = passenger.category.code + (discount > 0 ? '_discount' : '')

                if (!prices[key]) {
                    prices[key] = {
                        category: passenger.category.name,
                        quantity: 0,
                        total: 0,
                        discount: 0,
                        price: total,
                    }
                }

                prices[key].quantity += 1
                prices[key].total += total
                prices[key].discount += discount
            })

            return prices
        },
        transfer() {
            if (!this.quote.prices.transfers.length) return false

            return {
                name: this.quote.prices.transfers[0].name,
                total: this.quote.prices.transfers.reduce((total, transfer) => total += transfer.total, 0),
                quantity: this.quote.prices.passengers.length,
            }
        }
    },
    watch: {
        quoteArgs: {
            deep: true,
            handler() {
                this.getQuote()
            }
        }
    },
    methods: {
        ...mapActions('booking', [
            'getQuote'
        ]),
        toggleCart() {
            this.showCart = !this.showCart
        },
        hideCart() {
            this.showCart = false
        }
    }
}
</script>